import Crowdm1 from "./crowdm (1).webp";
import Crowdm2 from "./crowdm (2).webp";
import Crowdm3 from "./crowdm (3).webp";
import Crowdm4 from "./crowdm (4).webp";

const crowdm = [Crowdm1, Crowdm2, Crowdm3, Crowdm4];

export default crowdm;
